
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslations from './locales/en';
import frTranslations from './locales/fr';
import esTranslations from './locales/es';
import itTranslations from './locales/it';
import deTranslations from './locales/de';
import ruTranslations from './locales/ru';
import svTranslations from './locales/sv';
import ptTranslations from './locales/pt';
import zhTranslations from './locales/zh';
import arTranslations from './locales/ar';
import { SUPPORTED_LANGUAGES } from '@/constants/languages';

const i18nInstance = i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      fr: { translation: frTranslations },
      es: { translation: esTranslations },
      it: { translation: itTranslations },
      de: { translation: deTranslations },
      ru: { translation: ruTranslations },
      sv: { translation: svTranslations },
      pt: { translation: ptTranslations },
      zh: { translation: zhTranslations },
      ar: { translation: arTranslations },
      // Note: Other language resources will be loaded on demand
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    // Add missing keys functionality to show missing translations
    saveMissing: true,
    missingKeyHandler: (lng, ns, key) => {
      console.warn(`Missing translation key: ${key} for language: ${lng}`);
    }
  });

// Add a languages property to the i18n instance using the language codes from SUPPORTED_LANGUAGES
const i18nWithLanguages = i18n as typeof i18n & { languages: string[] };
i18nWithLanguages.languages = SUPPORTED_LANGUAGES.map(lang => lang.value);

export default i18nWithLanguages;
